import { useAbility as useA } from "@casl/react";
import AbilityContext, { AppAbility } from "../contexts/AbilityContext";
import useAuthStore from "./useAuthStore";

export default () => {
  const ability = useAuthStore(s => s.ability);
  return ability;
};
